module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-your-why-large-167aae30ab414fcdabf58aff18675ba7.jpg";